import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function StarIcon(props: IconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 35 35">
      <path
        fill="currentColor"
        d="M16.555 1.67c.3-.922 1.603-.922 1.902 0l3.315 10.201a1 1 0 0 0 .95.691H33.45c.969 0 1.372 1.24.588 1.81l-8.678 6.304a1 1 0 0 0-.363 1.118l3.315 10.202c.299.921-.756 1.687-1.54 1.118l-8.677-6.305a1 1 0 0 0-1.176 0L8.24 33.114c-.784.57-1.838-.197-1.539-1.118l3.315-10.202a1 1 0 0 0-.363-1.118L.975 14.371c-.784-.57-.381-1.809.587-1.809H12.29a1 1 0 0 0 .951-.69L16.555 1.67Z"
      />
    </SvgIcon>
  );
}
